import React, { useState } from "react";
import ModalV2 from "../../../../../shared/components/modalV2";
import { GREEN_CLOSE_BTN } from "../../../../../assets";

interface SetupMeetingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const SetupMeetingModal: React.FC<SetupMeetingModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
}) => {
  const [email, setEmail] = useState("");
  const [names, setNames] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmit = () => {
    onSubmit();
  };

  return (
    <ModalV2
      isOpen={isOpen}
      isClose={onClose}
      maxWidth="w-[540px]"
      edges="rounded-2xl"
    >
      <div className="w-full px-10 py-8 flex flex-col gap-6 text-left">
        <div className="flex items-start justify-between">
          <h2 className="text-xl font-bold text-[#101828] text-left">
            Set up Meeting
          </h2>
          <button onClick={onClose} className="mt-1">
            <img
              src={GREEN_CLOSE_BTN}
              alt="Close"
              className="w-5 h-5 cursor-pointer"
            />
          </button>
        </div>

        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <label className="text-sm font-medium text-[#101828] text-left">
              Email of the person(s) you are meeting
            </label>
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email, separate with comma"
              className="w-full px-4 py-3 border border-[#D0D5DD] rounded-lg text-sm placeholder:text-[#98A2B3] focus:outline-none focus:border-[#00B074]"
            />
          </div>

          <div className="flex flex-col gap-2">
            <label className="text-sm font-medium text-[#101828] text-left">
              Name of the person(s)
            </label>
            <input
              type="text"
              value={names}
              onChange={(e) => setNames(e.target.value)}
              placeholder="Name, separate with comma"
              className="w-full px-4 py-3 border border-[#D0D5DD] rounded-lg text-sm placeholder:text-[#98A2B3] focus:outline-none focus:border-[#00B074]"
            />
          </div>

          <div className="flex flex-col gap-2">
            <label className="text-sm font-medium text-[#101828] text-left">
              Brief description of meeting
            </label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder=""
              rows={4}
              className="w-full px-4 py-3 border border-[#D0D5DD] rounded-lg text-sm placeholder:text-[#98A2B3] focus:outline-none focus:border-[#00B074] resize-none"
            />
          </div>
        </div>

        <button
          onClick={handleSubmit}
          className="w-full bg-[#00B074] text-white py-3 rounded-lg font-medium hover:bg-[#009060] transition-colors"
        >
          Ok
        </button>
      </div>
    </ModalV2>
  );
};

export default SetupMeetingModal;
